import Request from './Request'

const UserService = {
	async getUsers() {
		const users = await Request.get('/api/users')
		return users
	},
	async getUserById(id) {
		const user = await Request.get(`/api/users/${id}`)
		return user
	},
	async createUser(name, email) {
		const user = await Request.post('/api/users', {
			name, email
		})
		return user
	},
	async updateUserById(id, data) {
		return await Request.post(`/api/users/${id}`, data)
	},
	async deleteById(id) {
		return await Request._delete(`/api/users/${id}`)
	},
	async undeleteById(id) {
		return await Request.post(`/api/users/${id}/restore`)
	},
	async getUserRoles(id) {
		const links = await Request.get(`/api/users/${id}/roles`)
		return links
	},
	async login(email, password) {
		return await Request.post('/api/login', {email, password})
	},
	async getCurrentUser() {
		return await Request.get('/api/user/current')
	},
	async resetActivationKey(id) {
		return await Request.post(`/api/users/${id}/reset-activation-key`)
	},
	async assignUserToRole(user_id, role_id, client_id=null, location_id=null) {
		return await Request.post(`/api/users/${user_id}/role-links/${role_id}`, {
			client_id, 
			location_id
		})
	},
	async unassignUserAndRole(user_id, link_id) {
		return await Request._delete(`/api/users/${user_id}/role-links/${link_id}`)
	},
	async sendResetPasswordEmail(user_id) {
		return await Request.post(`/api/users/${user_id}/reset-password`)
	},
	async getAdminUsers() {
		return await Request.get('/api/admin-users')
	},
	async getMyCurrentPermissions() {
		return await Request.get('/api/user/permissions/current')
	},
	async getUserClients() {
		return await Request.get('/api/user/client-list')
	},
	async getZendUrl() {
		return Request.get("/api/zendesk/get-zendesk-payload");
	}
}

export default UserService